// NOTE
// This is a "special" react component that does not strictly play by
// React's rules.
//
// Conceptually, this component creates a "portal" in React by
// closing its render method off from updates (by simply rendering a div and
// never accepting re-renders) then reconnecting itself to the React lifecycle
// by listening for any new props (using componentWillReceiveProps)

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { loadModules } from 'esri-loader';
import { createView } from '../utils/esriLoader';
import { getLayerLookup, getTableLookup } from '../utils/helpers';
import LayerManager from './LayerManager';
import * as widgets from './widgets';
import AutomaticSpatialQueryToggle from './widgets/AutomaticSpatialQueryToggle';
import './Map.css';
import { applyFieldArrayOverrides } from '../utils/helpers.js';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { mapOperations } from '../redux/map';

class Map extends Component {
  state = {
    mapViewReady: false
  };

  componentDidMount() {
    this.startup(
      !this.props.appConfig.is_next ? process.env.REACT_APP_WEBMAPID : process.env.REACT_APP_WEBMAPID_NEXT,
      this.props.user
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Tell React to never update this component, that's up to us
    // Exception: re-rendering once to load components that rely on mapViewReady
    return !this.state.mapViewReady && nextState.mapViewReady;

  }

  componentWillReceiveProps(nextProps) {
    // can hook into any updated props
  }

  componentWillUnmount() {
    // Clean up jsapi's dirty little mess
  }

  render() {
    return (
      <div ref="mapDiv" id="viewContainer">
        {!this.props.isDetailMap &&
          this.state.mapViewReady &&
          ReactDOM.createPortal(
            <AutomaticSpatialQueryToggle />,
            this.automaticSpatialQueryToggleNode
          )}
      </div>
    );
  }

  //
  // JSAPI Stuff
  //

  startup = (webmapId, user) => {
    const node = this.refs.mapDiv;
    createView(node, webmapId).then(
      response => {
        this.init(response);
        const config = this.props.appConfig;
        const getLayerManager = new LayerManager(
          this.view,
          this.layers,
          this.tables,
          config
        );
        this.basemapToggle = new widgets.BasemapToggle(this.view);
        this.search = new widgets.Search(this.view);
        this.locate = new widgets.Locate(this.view);
        this.PopupActionCreator = new widgets.PopupActionCreator(this.view, {
          history: this.props.history,
          layerLookup: this.layers,
          config
        });

        this.automaticSpatialQueryToggleNode = document.createElement('div');
        this.view.ui.add(this.automaticSpatialQueryToggleNode, 'bottom-left');

        const incidentsLayer = this.layers[config.layers.INCIDENTS];
        const resourcesLayer = this.layers[config.layers.RESOURCES];
        const incidentHistoryLayer = this.layers[
          config.layers.INCIDENT_HISTORY
        ];

        const pi = new Promise((resolve, reject) =>
          incidentsLayer.when(layer => resolve(layer))
        );
        const ph = new Promise((resolve, reject) =>
          incidentHistoryLayer.when(layer => resolve(layer))
        );
        const pr = new Promise((resolve, reject) =>
          resourcesLayer.when(layer => resolve(layer))
        );

        Promise.all([getLayerManager, pi, ph, pr]).then(
          ([
            layerManager,
            incidentsLayer,
            incidentHistoryLayer,
            resourcesLayer
          ]) => {
            // find and set these layers' field definition overrides
            // before setting the redux field defintions props

            applyFieldArrayOverrides(incidentsLayer.fields, 'incident');
            this.props.setFieldDefs(incidentsLayer.fields, 'incidents');

            applyFieldArrayOverrides(
              incidentHistoryLayer.fields,
              'incidentHistory'
            );
            this.props.setFieldDefs(
              incidentHistoryLayer.fields,
              'incidentHistory'
            );

            applyFieldArrayOverrides(resourcesLayer.fields, 'resource');
            this.props.setFieldDefs(resourcesLayer.fields, 'resources');

            this.props.setIncidentFilterDefs(incidentsLayer.fields);

            this.layerManager = layerManager;
            this.setupEventHandlers(this.view);

            this.setState({ mapViewReady: true });

            this.finishedLoading();
          }
        );
      },
      error => console.error(error)
    );
  };

  finishedLoading = () => {
    // Update app state only after map and widgets are loaded
    this.props.onMapLoaded();
  };

  init = response => {
    this.webmap = response.webmap;
    this.view = response.view;
    this.map = response.view.map;
    this.layers = getLayerLookup(this.webmap.layers);
    this.tables = getTableLookup(this.webmap.tables);

    // loadModules(['dojo/dom-construct']).then(([domConstruct]) => {
    //   this.view.ui.add(
    //     React.createElement('div', [], 'test'),
    //     /*domConstruct.create('p', {
    //       innerHTML: `<input type="checkbox" /> Filter table by map extent`
    //     }),*/
    //     'bottom-left'
    //   );
    // });
  };

  setupEventHandlers = view => {
    loadModules(['esri/core/watchUtils', 'dojo/topic']).then(
      ([watchUtils, topic]) => {
        //
        // JSAPI Map Event Handlers go here!
        //

        // watch for extent changes
        watchUtils.whenTrue(this.view, 'stationary', () => {
          if (this.view.extent) {
            this.props.setExtent(this.view.extent);
          }
        });
      }
    );
  };
}

const mapStateToProps = state => ({
  map: state.map
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...mapOperations
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Map);



// WEBPACK FOOTER //
// ./src/esri/Map.js